import { Route, Routes } from 'react-router-dom'
import AppLayout, { OpenLayout, PublicOnlyLayout } from './components/AppLayout.jsx'
import Feed from './pages/Feed.jsx'
import Login from './pages/Login.jsx'
import Welcome from './pages/Welcome.jsx'
import ForgotPassword from './pages/ForgotPassword.jsx'
import ResetPassword from './pages/ResetPassword.jsx'
import VerifyEmail from './pages/VerifyEmail.jsx'
import Profile from './pages/Profile.jsx'
import Settings from './pages/Settings.jsx'
import Search from './pages/Search.jsx'
import Album from './pages/Album.jsx'
import Artist from './pages/Artist.jsx'
import Song from './pages/Song.jsx'
import Charts from './pages/Charts.jsx'
import Compare from './pages/Compare.jsx'
import Notifications from './pages/Notifications.jsx'
import QueuePage from './pages/QueuePage.jsx'
import ImportPage from './pages/ImportPage.jsx'
import ImportReview from './pages/ImportReview.jsx'
import ListDetail from './pages/ListDetail.jsx'
import ReviewDetail from './pages/ReviewDetail.jsx'
import AdminReports from './pages/AdminReports.jsx'
import Legal from './pages/Legal.jsx'
import CancelDeletion from './pages/CancelDeletion.jsx'
import AccountDeleted from './pages/AccountDeleted.jsx'
import ExportDownload from './pages/ExportDownload.jsx'
import NotFound from './pages/NotFound.jsx'

/**
 * Only routes that exist (PLAN §7, Phase 1A). A link to a page nobody has
 * built is a bug report waiting to be filed.
 *
 * Three shells, and which one a route is in is a decision rather than a
 * detail. `PublicOnlyLayout` sends a signed-in visitor home — right for a
 * login form, wrong for the terms. `AppLayout` sends a signed-out one to the
 * login form — right for the feed, wrong for a deletion link that only exists
 * because there is no session left. `OpenLayout` refuses nobody.
 */
export default function App() {
  return (
    <Routes>
      <Route element={<PublicOnlyLayout />}>
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/reset" element={<ResetPassword />} />
      </Route>

      {/* Reachable either way: the link arrives by email, signed in or not. */}
      <Route path="/verify" element={<VerifyEmail />} />

      <Route element={<OpenLayout />}>
        <Route path="/legal/:page" element={<Legal />} />
        <Route path="/settings/export/:id" element={<ExportDownload />} />
        <Route path="/account/cancel-deletion" element={<CancelDeletion />} />
        <Route path="/account/deleted" element={<AccountDeleted />} />
        {/* The catch-all belongs here rather than inside `AppLayout`, where it
            was unreachable to anybody signed out: a stale or mistyped link sent
            a stranger to the login form, which tells them their session is the
            problem when their link was. `OpenLayout` refuses nobody and still
            renders the nav for somebody signed in, so both audiences are told
            the same true thing. Ranking decides this rather than order — every
            route in either block is more specific than `*`. */}
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route element={<AppLayout />}>
        <Route index element={<Feed />} />
        <Route path="/search" element={<Search />} />
        <Route path="/album/:id" element={<Album />} />
        <Route path="/artist/:id" element={<Artist />} />
        <Route path="/song/:id" element={<Song />} />
        <Route path="/reviews/:id" element={<ReviewDetail />} />
        <Route path="/lists/:id" element={<ListDetail />} />
        <Route path="/charts" element={<Charts />} />
        <Route path="/queue" element={<QueuePage />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/import/review" element={<ImportReview />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/profile/:handle" element={<Profile />} />
        <Route path="/compare/:handle" element={<Compare />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin/reports" element={<AdminReports />} />
      </Route>
    </Routes>
  )
}
